(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-image-multiple"] && !Shopify.designMode) return;
  try {
    
function initBeforeAfterSwipers() {
  if (typeof window.Swiper === "undefined") {
    setTimeout(initBeforeAfterSwipers, 50);
    return;
  }

  document.querySelectorAll(".before-after-swiper").forEach(function(el) {
    if (el.classList.contains("swiper-initialized")) return;

    const nextButton = el.querySelector(".swiper-button-next");
    const prevButton = el.querySelector(".swiper-button-prev");

    const swiper = new Swiper(el, {
      slidesPerView: "auto",
      autoplay: false,
      loop: true,
      a11y: false,
      centeredSlides: true,
      allowTouchMove: false,
      spaceBetween: 40
    });

    if (nextButton) {
      nextButton.addEventListener("click", function() {
        swiper.slideNext();
      });
    }

    if (prevButton) {
      prevButton.addEventListener("click", function() {
        swiper.slidePrev();
      });
    }
  });
}

window.addEventListener("load", initBeforeAfterSwipers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom--category--collection-list-swiper"] && !Shopify.designMode) return;
  try {
    





  var slider = new Swiper('.mySwiper2', {
     slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
     thumbs: {
        swiper: swiper,
       thumbsContainerClass: 'swiper-thumbs',
       multipleActiveThumbs: true,
       
      },
    slideToClickedSlide: true,
    
  });

   var swiper = new Swiper(".mySwiper", {
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
    });

  

  } catch(e) { console.error(e); }
})();
})();
